var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 230,
    viewBox: "0 0 163 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 104H144V183H20V104Z",
    fill: "#ECEEF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 104V224H0V151.437L20 104Z",
    fill: "#DADEE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144 104V223H163V151.437L144 104Z",
    fill: "#DADEE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 151.5H162.5V225C162.5 227.485 160.485 229.5 158 229.5H5C2.51472 229.5 0.5 227.485 0.5 225V151.5Z",
    fill: "white",
    stroke: "#DADEE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 172H61V209V210H62H103V209H62V172ZM70 192H66V205H70V192ZM72 186H76V205H72V186ZM82 195H78V205H82V195ZM84 188H88V205H84V188ZM94 178H90V205H94V178ZM96 174H100V205H96V174Z",
    fill: "#DADEE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6168 77.7185C59.3462 92.9635 50.5395 110.461 38.3614 123.762C50.815 128.394 73.053 134.16 90.7846 137.063C91.6281 137.201 94.1214 136.533 94.9294 136.56C99.8144 136.723 102.022 132.885 103.692 131.588C110.073 122.678 116.639 115.967 118.836 104.418C119.962 98.4967 120.372 93.5315 120.128 91.4585C113.276 86.6824 98.8124 88.8777 54.6168 77.7185Z",
    fill: "#DADEE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5397 126.425C99.3445 129.82 95.5883 137.697 89.4584 136.908C95.9775 137.682 99.7484 135.678 102.535 133.563C105.322 131.448 118.391 121.644 120.083 91.502C117.61 116.874 110.078 128.595 96.5397 126.425Z",
    fill: "#B6BDC4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.433 25.7486C115.433 25.7486 117.831 30.3634 119.257 34.4298C121.236 40.0732 120.234 46.6594 119.943 46.7394C118.355 47.1757 112.49 39.7765 112.34 35.2659C112.206 31.2098 115.433 25.7486 115.433 25.7486Z",
    fill: "#DADEE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8606 45.064C39.8606 45.064 71.3725 35.8266 81.1614 9.95298C85.8946 10.746 94.3415 14.42 114.983 25.3353C117.867 26.86 112.371 35.213 112.371 35.213C112.371 35.213 122.117 42.8681 119.998 46.2422C107.75 65.7448 97.5311 73.1304 85.3779 74.2125C66.2526 70.5778 39.8606 45.064 39.8606 45.064Z",
    fill: "#F5F6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReport);
export default __webpack_public_path__ + "static/media/empty-report.79cdfdaa4ded6abbf41de9e67136065a.svg";
export { ForwardRef as ReactComponent };